import { useEffect } from "react";
import { Link } from "react-router-dom";
import Gallery from "../components/Gallery";
import ReviewsSlider from "../components/ReviewsSlider";
import ContactForm from "../components/ContactForm";

export default function Home() {
  useEffect(() => {
    document.title = "FYNS AFLØBSTEKNIK – Aut. Kloakmester";
  }, []);

  const services = [
    {
      title: "ROTTESPÆRRE",
      slug: "/rottespaerre",
      description: "Jeg er ekspert i at sikre dit hjem mod rotter",
      icon: "fa-shield-halved",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-header-img-scaled.jpg"
    },
    {
      title: "HØJVANDSLUKKE",
      slug: "/hoejvandslukke",
      description: "Læs mere om hvordan jeg kan sikre dig mod vandskade",
      icon: "fa-water",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-flood-header2-scaled.jpg"
    },
    {
      title: "KLOAK TV",
      slug: "/kloak-tv",
      description: "Med TV-inspektion kan du få kontrolleret din kloaks tilstand",
      icon: "fa-video",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-kloaktc-header-scaled.jpg"
    },
    {
      title: "PUNKTREPARATION",
      slug: "/punktreparation",
      description: "Punktreparation af kloakskade uden opgravning",
      icon: "fa-wrench",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-punktrep-header-scaled.jpg"
    },
    {
      title: "SPULING/SLAMSUGNING",
      slug: "/spuling-slamsugning",
      description: "Professionel spuling og slamsugning af autoriseret kloakmester",
      icon: "fa-truck-droplet",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-1409.webp"
    },
    {
      title: "RÅD MOD ROTTER",
      slug: "/raad-mod-rotter",
      description: "Her er 5 gode råd, du kan følge for at sikre dig mod rotter",
      icon: "fa-triangle-exclamation",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-rat-header-scaled.jpg"
    },
    {
      title: "OM FYNS AFLØBSTEKNIK",
      slug: "/om-fyns-afloebsteknik",
      description: "Læs mere om Fyns afløbsteknik og hvad jeg kan gøre for dig.",
      icon: "fa-user-tie",
      image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-6-fynsafloebsteknik1.jpg"
    }
  ];

  return (
    <div className="bg-white text-neutral-900">
      {/* HERO SECTION - Mørk, markant med sort firmabil og logo */}
      <section className="relative bg-[#0d1117] text-white overflow-hidden">
        {/* Background Subtle Gradient/Grid */}
        <div className="absolute inset-0 bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:24px_24px] opacity-25" />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            {/* Tekstkolonne */}
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-neutral-800/80 border border-neutral-700 text-xs sm:text-sm text-neutral-300 font-semibold">
                <span className="w-2 h-2 rounded-full bg-neutral-300 animate-pulse" />
                <span>Autoriseret Kloakmester på hele Fyn</span>
              </div>

              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
                Velkommen til <br className="hidden sm:inline" />
                <span className="text-white">Fyns Afløbsteknik ApS</span>
              </h1>

              <div className="text-lg sm:text-xl font-bold text-neutral-200 border-l-4 border-neutral-400 pl-4 py-1">
                Er din kloak eller dit afløb stoppet? Så har du her fat i den helt rigtige hjælp.
              </div>

              <p className="text-neutral-300 text-base sm:text-lg leading-relaxed max-w-2xl">
                Mit navn er Morten Chylenski og jeg står klar hvis du har brug for en seriøs og professionel kloakmester, med mange års erfaring og den helt rette uddannelse i ryggen.
              </p>

              {/* Call to actions */}
              <div className="pt-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                <a
                  href="tel:50493950"
                  className="bg-white hover:bg-neutral-200 text-black font-extrabold px-7 py-4 rounded-lg text-base shadow-xl flex items-center justify-center gap-3 transition-colors no-break"
                >
                  <i className="fa-solid fa-phone text-neutral-700" aria-hidden="true" />
                  <span className="no-break">Ring 50 49 39 50</span>
                </a>

                <Link
                  to="/kontakt"
                  className="bg-[#1f2937] hover:bg-[#374151] text-white font-bold px-7 py-4 rounded-lg text-base border border-neutral-700 flex items-center justify-center gap-2 transition-colors"
                >
                  <span>Kontakt os</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
              </div>

              {/* Trust badges */}
              <div className="pt-6 border-t border-neutral-800 flex flex-wrap items-center gap-6 text-xs text-neutral-400">
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-check-circle text-neutral-400" aria-hidden="true" />
                  <span>Sikkerhedsstyrelsen godkendt</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-check-circle text-neutral-400" aria-hidden="true" />
                  <span>Validan kontrolinstans</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-check-circle text-neutral-400" aria-hidden="true" />
                  <span>Mange års erfaring</span>
                </div>
              </div>
            </div>

            {/* Billedekolonne - Sorte firmabiler & udstyr */}
            <div className="lg:col-span-5">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-neutral-700 bg-neutral-900 group">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-6-fynsafloebsteknik1.jpg"
                  alt="Fyns Afløbsteknik professionel servicevogn på Fyn"
                  className="w-full h-[380px] sm:h-[440px] object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-6">
                  <div className="flex items-center gap-3 bg-black/60 backdrop-blur-sm p-3 rounded-lg border border-neutral-700">
                    <img
                      src="https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/cropped-fyat-logo-1-180x180.png"
                      alt="Logo"
                      className="h-10 w-10 object-contain rounded brightness-0 invert"
                    />
                    <div>
                      <span className="text-xs text-neutral-400 uppercase tracking-wider font-semibold block">
                        Faglig garanti & lokalt kendskab
                      </span>
                      <span className="text-sm font-bold text-white">
                        Kører ud fra Odense til hele Fyn
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* YDELSER SEKTION - Rent hvidt/lyst baggrund med markante kort */}
      <section className="py-20 bg-neutral-50 border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-14">
            <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-neutral-500 block mb-2">
              Vores Ydelser
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-neutral-900 tracking-tight">
              Kloakarbejde & Afløbsteknik af Højeste Kvalitet
            </h2>
            <p className="text-neutral-600 mt-3 text-base sm:text-lg">
              Vi løser alle former for opgaver inden for rottesikring, kloakinspektion, skybrudssikring og skånsom rørrenovering.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => {
              const imageUrl = service.image.includes("imgi-") || service.image.includes("fynsafloebsteknik")
                ? service.image
                : `https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/${service.image.replace("https://assets.auxodev.dk/", "")}`;

              return (
                <div
                  key={service.slug}
                  className="bg-white rounded-xl border border-neutral-200 overflow-hidden shadow-sm flex flex-col justify-between"
                >
                  <div>
                    <div className="relative h-48 overflow-hidden bg-neutral-900">
                      <img
                        src={imageUrl}
                        alt={service.title}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                      <div className="absolute top-4 left-4 w-10 h-10 rounded-lg bg-black/80 text-white flex items-center justify-center text-base shadow">
                        <i className={`fa-solid ${service.icon}`} aria-hidden="true" />
                      </div>
                    </div>

                    <div className="p-6">
                      <h3 className="text-xl font-bold text-neutral-900 mb-2">
                        {service.title}
                      </h3>
                      <p className="text-neutral-600 text-sm leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>

                  <div className="px-6 pb-6 pt-2">
                    <Link
                      to={service.slug}
                      className="inline-flex items-center gap-2 text-sm font-bold text-neutral-900 hover:text-neutral-600 transition-colors"
                    >
                      <span>Læs mere</span>
                      <i className="fa-solid fa-arrow-right text-xs text-neutral-500" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CERTIFIKATION & SPECIALE SEKTION - Markant, tillidsvækkende sektion */}
      <section className="py-16 bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#0f141c] text-white rounded-2xl p-8 sm:p-12 border border-neutral-800 shadow-xl">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
              
              <div className="lg:col-span-4 space-y-4">
                <span className="text-xs uppercase font-bold tracking-widest text-neutral-400 block">
                  Certificeret Kvalitet
                </span>
                <h3 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">
                  Validan Kontrolinstans
                </h3>
                <div className="bg-white p-4 rounded-xl inline-block shadow">
                  <img
                    src="/images/validan-logo.svg"
                    alt="Validan Kontrolinstans"
                    className="h-16 w-auto object-contain"
                  />
                </div>
                <p className="text-sm text-neutral-300 leading-relaxed">
                  Godkendt af Sikkerhedsstyrelsen som kontrolinstans inden for autorisationsområdet kloak.
                </p>
              </div>

              <div className="lg:col-span-8 border-t lg:border-t-0 lg:border-l border-neutral-800 pt-8 lg:pt-0 lg:pl-10">
                <h4 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
                  <i className="fa-solid fa-star text-neutral-400" aria-hidden="true" />
                  <span>Vores Specialer</span>
                </h4>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="bg-neutral-900/90 border border-neutral-800 p-4 rounded-lg flex items-start gap-3">
                    <div className="w-8 h-8 rounded bg-neutral-800 text-neutral-300 border border-neutral-700 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="fa-solid fa-shield-halved text-sm" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="font-bold text-white text-sm block">Rottesikring</span>
                      <span className="text-xs text-neutral-400">Rottesikring af kloaksystemer med godkendt rottespærre</span>
                    </div>
                  </div>

                  <div className="bg-neutral-900/90 border border-neutral-800 p-4 rounded-lg flex items-start gap-3">
                    <div className="w-8 h-8 rounded bg-neutral-800 text-neutral-300 border border-neutral-700 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="fa-solid fa-cloud-showers-heavy text-sm" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="font-bold text-white text-sm block">Højvandslukke</span>
                      <span className="text-xs text-neutral-400">Sikring mod oversvømmelse ved skybrud og opstuvning</span>
                    </div>
                  </div>

                  <div className="bg-neutral-900/90 border border-neutral-800 p-4 rounded-lg flex items-start gap-3">
                    <div className="w-8 h-8 rounded bg-neutral-800 text-neutral-300 border border-neutral-700 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="fa-solid fa-clipboard-check text-sm" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="font-bold text-white text-sm block">Lovpligtigt serviceeftersyn</span>
                      <span className="text-xs text-neutral-400">Service og kontrol af alle afløbsinstallationer</span>
                    </div>
                  </div>

                  <div className="bg-neutral-900/90 border border-neutral-800 p-4 rounded-lg flex items-start gap-3">
                    <div className="w-8 h-8 rounded bg-neutral-800 text-neutral-300 border border-neutral-700 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="fa-solid fa-smog text-sm" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="font-bold text-white text-sm block">Røgprøvning</span>
                      <span className="text-xs text-neutral-400">Lokalisering af skjulte utætheder og lugtgener</span>
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex flex-wrap items-center gap-4 text-sm">
                  <a
                    href="tel:50493950"
                    className="bg-neutral-100 hover:bg-white text-neutral-900 font-bold px-5 py-2.5 rounded transition-colors flex items-center gap-2 no-break"
                  >
                    <i className="fa-solid fa-phone text-neutral-800" aria-hidden="true" />
                    <span className="no-break">Kontakt kloakmesteren</span>
                  </a>
                  <span className="text-neutral-400 text-xs sm:text-sm">
                    CVR: 40617361 • Brolandvej 78, 5320 Agedrup
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ANMELDELSER INFINITE SLIDER */}
      <section className="py-20 bg-[#0d1117] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-neutral-400 block mb-2">
              Kundetilfredshed
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
              Hvad siger kunderne om Fyns Afløbsteknik?
            </h2>
            <p className="text-neutral-400 text-base sm:text-lg mt-3">
              Vi sætter en ære i at overholde aftaler, levere topkvalitet og sikre dit hjem.
            </p>
          </div>

          <ReviewsSlider />
        </div>
      </section>

      {/* 3-KOLONNET KONTAKTSEKTION (Match design reference Webform) */}
      <section className="bg-neutral-950 border-t border-neutral-800 text-white">
        <div className="w-full">
          <div className="grid grid-cols-1 lg:grid-cols-3 min-h-[620px]">
            
            {/* 1. Venstre kolonne: Full-bleed map embed */}
            <div className="relative w-full h-[360px] sm:h-[420px] lg:h-full min-h-[360px] lg:min-h-full bg-neutral-900">
              <iframe
                title="Fyns Afløbsteknik Placering på kort"
                src="https://maps.google.com/maps?q=Brolandvej%2078%205320%20Agedrup&t=&z=13&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0 absolute inset-0 grayscale contrast-125 opacity-90 hover:opacity-100 transition-opacity"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* 2. Midterste kolonne: Kontaktinfo mod subtil baggrundsflade */}
            <div className="bg-[#10151d] p-8 sm:p-10 lg:p-12 flex flex-col justify-between border-t lg:border-t-0 lg:border-x border-neutral-800/80">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-neutral-400 block mb-2">
                  Find os & Kontakt
                </span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight mb-3">
                  Vi dækker hele Fyn
                </h2>
                <p className="text-neutral-400 text-sm leading-relaxed mb-8">
                  Fyns Afløbsteknik ligger i Odenses nordøstligste bydel (Agedrup). Herfra rykker vi hurtigt ud til alle de fynske flækker.
                </p>

                {/* 3 vertikale kontaktdetaljeblokke */}
                <div className="space-y-6">
                  {/* Blok 1: Telefon */}
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-neutral-800/90 border border-neutral-700/80 text-neutral-200 flex items-center justify-center shrink-0 text-base shadow-xs">
                      <i className="fa-solid fa-phone text-neutral-300" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-semibold uppercase tracking-wider text-neutral-400 block">
                        Telefon & Døgnvagt
                      </span>
                      <a
                        href="tel:50493950"
                        className="text-lg font-bold text-white hover:text-neutral-300 transition-colors no-break block mt-0.5"
                      >
                        50 49 39 50
                      </a>
                      <span className="text-xs text-neutral-400 block mt-0.5">
                        Døgnvagt og hurtig udrykning
                      </span>
                    </div>
                  </div>

                  {/* Blok 2: E-mail */}
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-neutral-800/90 border border-neutral-700/80 text-neutral-200 flex items-center justify-center shrink-0 text-base shadow-xs">
                      <i className="fa-solid fa-envelope text-neutral-300" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-semibold uppercase tracking-wider text-neutral-400 block">
                        Direkte E-mail
                      </span>
                      <a
                        href="mailto:mc@fyat.dk"
                        className="text-lg font-bold text-white hover:text-neutral-300 transition-colors no-break block mt-0.5"
                      >
                        mc@fyat.dk
                      </a>
                      <span className="text-xs text-neutral-400 block mt-0.5">
                        Morten Chylenski • Hurtigt svar
                      </span>
                    </div>
                  </div>

                  {/* Blok 3: Adresse */}
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-neutral-800/90 border border-neutral-700/80 text-neutral-200 flex items-center justify-center shrink-0 text-base shadow-xs">
                      <i className="fa-solid fa-location-dot text-neutral-300" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-semibold uppercase tracking-wider text-neutral-400 block">
                        Adresse & CVR
                      </span>
                      <p className="text-base font-bold text-white mt-0.5">
                        Brolandvej 78, 5320 Agedrup
                      </p>
                      <span className="text-xs text-neutral-400 block mt-0.5">
                        CVR: 40617361 • Aut. Kloakmester
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-8 mt-8 border-t border-neutral-800/80">
                <p className="text-xs text-neutral-500 leading-relaxed">
                  Autoriseret kloakmester med certifikat fra Validan.
                </p>
              </div>
            </div>

            {/* 3. Højre kolonne: Kontaktformular på ren overflade */}
            <div className="bg-[#0b0e14] p-8 sm:p-10 lg:p-12 flex flex-col justify-center">
              <ContactForm
                title="Send en besked"
                subtitle="Udfyld felterne, så vender vi tilbage hurtigst muligt med vejledning eller et uforpligtende tilbud."
                className="w-full"
              />
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
